import React from 'react';
import { DataGridIdentifier as DataGridIdentifierContext } from './context';

interface IDataGridIdentifier {
  children: React.ReactNode;
  gridId: string;
}

const DataGridIdentifier = ({ children, gridId }: IDataGridIdentifier) => {
  return (
    <DataGridIdentifierContext.Provider
      value={React.useMemo(() => ({ gridId }), [gridId])}
    >
      {children}
    </DataGridIdentifierContext.Provider>
  );
};

export default React.memo(DataGridIdentifier);
